import { Options } from 'types/BankAccountsDetails'

const useDepositPaymentReference = (options: Options) => {
  return `${options?.metaData?.referencePrefix ?? ''}${
    options?.referenceNumber ?? options?.reference ?? ''
  }`
}

export default useDepositPaymentReference
